import React from 'react';
import { Box, Typography } from '@mui/material';
import ApiParametersTable from '../ApiParametersTable';
import ApiEndpointDisplay from '../ApiEndpointDisplay';
import ApiResponseExamples from '../ApiResponseExamples';
import ApiRequestExamples from '../ApiRequestExamples';

const SdVideoOnDemandApi: React.FC = () => {
    const parameters = [
        { type: 'HEAD', name: 'Authorization', dataType: 'string', required: true },
        { type: 'POST', name: 'vehicleId', dataType: 'string', required: true },
        { type: 'POST', name: 'cameraId', dataType: 'string', required: true },
        { type: 'POST', name: 'startDate', dataType: 'string', required: true },
        { type: 'POST', name: 'endDate', dataType: 'string', required: true },
        { type: 'POST', name: 'startTime', dataType: 'string', required: true },
        { type: 'POST', name: 'endTime', dataType: 'string', required: true },
    ];

    return (
        <Box className="flex flex-col border-b border-gray-200">
            <Typography variant="h6" marginBottom={1} fontWeight={600} fontSize={16} id="sd-video-demand">
                GET SD VIDEO ON DEMAND
            </Typography>
            
            <Typography variant='body2' marginBottom={2} fontSize={14} fontWeight={400}>
                To get the SD video filename for a specific vehicle, you must send a POST request. This request requires an Authorization token in the headers and a request body containing the details of the vehicle for which you want to retrieve the video filename.
            </Typography>
            <Typography variant='body2' marginBottom={1} fontSize={14} fontWeight={600}>Request</Typography>
            <ApiEndpointDisplay 
                method="POST" 
                url="https://backend.novusomnifleet.com/api/client/v1/file-from-sd-card" 
            />
            <ApiParametersTable parameters={parameters} />

            <ApiRequestExamples
                examples={[
                    {
                    type: "headers",
                    headers: [
                        {
                        key: "Authorization",
                        value:
                            "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJJQ1NBIiwidXNlcklkIjoiNjdkOTBkMDdlNGNhZTU3MDEwMzQyYzA4Iiwicm9sZXMiOiJST0xFX0ZMRUVUX01BTkFHRVIiLCJpYXQiOjE3NTQzNzIyNjksImV4cCI6MTc1NDQwODI2OX0.NItAkAwXNGKxoAsUTZSwB0lzFPHgW3I4ZwpLEY4c-Lo"
                        }
                    ],
                    label: "Request Headers"
                    },
                    {
                    type: "body",
                    contentType: "json",
                    value: `{
 "vehicleId": "S1234",
 "cameraId": "04",
 "startDate": "2025-06-05",
 "endDate": "2025-07-21",
 "startTime": "13:04:48",
 "endTime": "22:10:45"
}`,
                    label: "Request Body"
                    }
                ]}
            />

            <ApiResponseExamples 
                examples={[
                    {
                        status: '200',
                        description: 'Success',
                        response: `{
                                      "data": {
                                        "cameraId": "2",
                                        "mediaFiles": [
                                          {
                                            "startTime": "2025-07-31:08:24:00",
                                            "endTime": "2025-07-31:08:25:00",
                                            "status": "UNAVAILABLE"
                                          },
                                          {
                                            "startTime": "2025-07-31:08:25:10",
                                            "endTime": "2025-07-31:08:26:10",
                                            "status": "AVAILABLE"
                                          },
                                          {
                                            "startTime": "2025-07-31:08:26:11",
                                            "endTime": "2025-07-31:08:27:11",
                                            "status": "AVAILABLE"
                                          }
                                        ],
                                        "cameraName": "DSM"
                                      },
                                      "message": "Sd Card File Fetched Successfully",
                                      "status": 200
                                    }`
                    },
                    {
                        status: '400',
                        description: 'Missing vehicleId',
                        response: `{
                                      "success": false,
                                      "message": "Invalid request body",
                                      "errors": [
                                        {
                                          "code": "missing_field",
                                          "field": "vehicleId",
                                          "detail": "VehicleId is required"
                                        }
                                      ]
                                    }`
                    },
                    {
                        status: '400',
                        description: 'Missing startDate',
                        response: `{
                                      "success": false,
                                      "message": "Invalid request body",
                                      "errors": [
                                        {
                                          "code": "missing_field",
                                          "field": "startDate",
                                          "detail": "startDate is required"
                                        }
                                      ]
                                    }`
                    },
                    {
                        status: '401',
                        description: 'Unauthorized',
                        response: `{
                                      "success": false,
                                      "message": "Invalid username or password"
                                    }`
                    },
                    {
                        status: '500',
                        description: 'Server Error',
                        response: `{
                                      "success": false,
                                      "message": "An internal server error occurred"
                                    }`
                    }
                ]}
            />
        </Box>
    );
};
export default SdVideoOnDemandApi;
